module.exports = {
    title: "Business Traveller Reports",
    crud: {
        create: "Create Reports",
        edit: "Edit Reports",
        view: "View Reports",
    },
    table: {
        reason: "Reason",
        username: 'Username',
        isActive: "Active",
        description: "Description",
    },
    form: {
        reason: "Reason",
        username: 'Reported By',
        isActive: "Active",
        description: "Description",
    },
    validation: {
        required: {
            reason: 'Reason is required',
        },

    },
}
